import React from 'react';
import { Pressable, Text, View } from 'react-native';

import { getStationInfo } from '../../MapPlaces/apiCalls/getStationInfo';
import { stlBtnReturn, stlTag } from './styles';
import { setData } from '../../../project';
import { useData } from '../../../..';

type Tprops = {
  setError: React.Dispatch<React.SetStateAction<boolean>>;
  stationApiID: string;
};

export const LoopBtnReturn = (props: Tprops) => {
  const { setError, stationApiID } = props;

  const [sttStationBikes, setStationBikes] = React.useState([]);
  const currReturnBikeId = useData(ct => ct.sc.B5.currData.currReturnBikeId);

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const { foundBikes } = await getStationInfo(stationApiID, 'unlock');
        setStationBikes(foundBikes);
      } catch (error) {
        console.error('Erro ao buscar dados da estação:', error);
      }
    };

    fetchData();
  }, [stationApiID]);

  const btnReturn = number => {
    setData({ path: 'sc.B5.currData.currReturnBikeId', value: number });
    setError(false);
  };

  const emptyArray = sttStationBikes.length > 0;

  return (
    <>
      <View style={stlTag}>
        <Text style={{ color: 'white', marginRight: 15 }}>
          {sttStationBikes.length + ' Vagas Disponíveis'}
        </Text>
        {emptyArray ? (
          btnLoop(currReturnBikeId, sttStationBikes, btnReturn)
        ) : (
          <></>
        )}
      </View>
    </>
  );
};

type TStation = {
  rackID: number;
  status: 'unlock' | 'lock';
}[];

const btnLoop = (
  currReturnBikeId: number,
  sttStationBikes: TStation,
  btnReturn: (n: number) => void,
) =>
  sttStationBikes.map((i, idx) => {
    const condMatch = i.rackID === currReturnBikeId;
    const condColor = condMatch
      ? { backgroundColor: 'rgb(124, 35, 85)' }
      : { backgroundColor: 'rgba(119, 112, 116, 1)' };
    return (
      <Pressable
        key={idx}
        style={[stlBtnReturn, condColor]}
        onPress={() => btnReturn(i.rackID)}
      >
        <Text style={{ color: '#FFF' }}>{i.rackID}</Text>
      </Pressable>
    );
  });
